/**
 * @fileoverview Llamadas a Vive+ por Apigee (proxy api-ux-vivemas-benefits). El proxy exige `x-api-key` y las cuatro
 * cabeceras de trazabilidad en todas las rutas, pero buena parte de las llamadas las hace `CardsPromotion` de la
 * librería is-card-benefit con su propio `fetch` (lista de beneficios, cupón y calificación), sin cabeceras propias.
 * Por eso se envuelve `window.fetch`: toda llamada a `API_VIVEMAS` sale con las cabeceras de Apigee (con la key de
 * la App vivemas-benefits, `APIGEE_VIVEMAS_API_KEY`), y la
 * calificación que la librería envía fija al Cloud Run anterior se redirige al proxy.
 * @module utils/vivemasFetch
 */

import environment from './environment'
import { buildApigeeHeaders } from './apigeeHeaders'

/** Calificación que is-card-benefit (insertRating) envía fija al Cloud Run anterior, según su `origin`. */
export const LEGACY_RATING_URLS = [
  'https://vivemas-api-prod-mvwf7vmdzq-uk.a.run.app/vivemas/v2.0/rating',
  'https://vivemas-api-test-mvwf7vmdzq-uk.a.run.app/vivemas/v2.0/rating'
]

/**
 * Devuelve la URL a la que debe ir la llamada a Vive+, o null si la llamada no es a Vive+.
 * @param {string} url
 * @param {string} vivemasUrl - Base de Vive+ en Apigee
 * @returns {string|null}
 */
export function resolveVivemasUrl (url, vivemasUrl) {
  if (!vivemasUrl || typeof url !== 'string') {
    return null
  }
  if (LEGACY_RATING_URLS.indexOf(url) !== -1) {
    return vivemasUrl + '/rating'
  }
  return url.indexOf(vivemasUrl + '/') === 0 || url.indexOf(vivemasUrl + '?') === 0 || url === vivemasUrl ? url : null
}

/**
 * Envuelve un `fetch` para que las llamadas a Vive+ lleven las cabeceras de Apigee. El resto pasa sin cambios.
 * @param {function} originalFetch
 * @returns {function}
 */
export function createVivemasFetch (originalFetch) {
  return function (input, init) {
    const url = resolveVivemasUrl(input, environment.getVivemasApiUrl())
    if (!url) {
      return originalFetch(input, init)
    }
    const options = init || {}
    // Vive+ tiene su propia App en Apigee: se reemplaza la key de Zona Segura por la de Vive+
    const headers = { ...options.headers, ...buildApigeeHeaders(), 'x-api-key': environment.getVivemasApiKey() }
    return originalFetch(url, { ...options, headers })
  }
}

/**
 * Instala el envoltorio en `window.fetch`. Se llama una sola vez, al iniciar la app.
 */
export function installVivemasFetch () {
  window.fetch = createVivemasFetch(window.fetch.bind(window))
}



// WEBPACK FOOTER //
// ./src/utils/vivemasFetch.js